"use strict";
exports.__esModule = true;
require("core-js/modules/es.array.flat");
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.values");
require("core-js/modules/es.array.from");
var resize_observer_polyfill_1 = require("resize-observer-polyfill");
require("intersection-observer");
var smoothscroll_polyfill_1 = require("smoothscroll-polyfill");
// @ts-ignore
window.ResizeObserver = resize_observer_polyfill_1["default"];
// required for scrollTo methods
smoothscroll_polyfill_1.polyfill();
